module.exports = __webpack_public_path__ + "static/media/ThankYou.10df8475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/campaign/ThankYou.jpg
// module id = 1552
// module chunks = 0